import React from 'react';
import { JiraSubtask } from '../../domain/types';
import { Accordion, Pill } from '../../ui/common';

export interface JiraSubtasksSectionProps {
  ticket?: string;
  subtasks?: JiraSubtask[];
  onCycleState: (ticket: string, subtaskIndex: number) => void;
}

export const JiraSubtasksSection: React.FC<JiraSubtasksSectionProps> = ({
  ticket,
  subtasks = [],
  onCycleState,
}) => {
  if (!subtasks || subtasks.length === 0) return null;

  return (
    <Accordion title="Subtareas" defaultOpen={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {subtasks.map((s, sIdx) => {
          const subTone =
            s.status === 'Hecho'
              ? 'ok'
              : s.status === 'En curso'
                ? 'accent'
                : s.status === 'Bloqueado'
                  ? 'bad'
                  : 'flat';

          return (
            <div
              key={s.id || s.key}
              onClick={(e) => {
                e.stopPropagation();
                ticket && onCycleState(ticket, sIdx);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '7px 9px',
                borderRadius: 8,
                background: 'var(--z-fill-2)',
                cursor: 'pointer',
                border: 'none',
              }}
            >
              <span
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 10.5,
                  color: 'var(--z-faint)',
                }}
              >
                {ticket && s.key.startsWith(`${ticket}-`) ? s.key.replace(`${ticket}-`, '·') : s.key}
              </span>
              <span style={{ flex: '1 1 auto', minWidth: 0, fontSize: 12, color: 'var(--z-text-3)' }}>
                {s.summary}
              </span>
              <Pill label={s.status} tone={subTone} />


            </div>
          );
        })}
      </div>
    </Accordion>
  );
};
